import React, { useEffect } from "react";
import { useState } from "react";
import { NewTraining, newTrainings } from "../../../../const/newTraining";
import { inscribe } from "./Inscribe";
import ContactBar from "./ContactBar";

const Catalog = () => {

    const [ trainings, setTrainings ] = useState<NewTraining[]>([])

    // const [ activeId, setActiveId ] = useState<number | null>(null)
    const [ activeIds, setActiveIds ] = useState<number[]>([])

    // const toggleActive = (id: number) => {
    //     setActiveId(activeId === id ? null : id)
    // }

    const toggleActive = (id: number) => {
        if (activeIds.includes(id)) {
            setActiveIds(activeIds.filter(activeId => activeId !== id))
        } else {
            setActiveIds([...activeIds, id])
        }
    }

    useEffect(() => {
        setTrainings(newTrainings)
    }, [])

    const handleInscribe = (title: string) => {
        inscribe(title);
    }

    return(
        <>
        <div id="tab-catalogue" className="section">
            <div className="section-title">Catalogue des formations</div>
            <div className="section-sub">Cliquez sur un domaine pour voir le détail des formations</div>
                <div className="domains-grid">
                    {trainings.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '50px 0', color: '#555' }}>
                            <h2 style={{ fontSize: 24, marginBottom: 10 }}>Chargement du catalogue de formations...</h2>
                            <p style={{ fontSize: 16 }}>Veuillez patienter pendant que nous récupérons les données.</p>
                        </div>
                    )}
                    {trainings.length > 0 && (
                        trainings.map((training) => (
                            training.type === "catalog" && (
                            <div
                        // className={`domain-card ${activeId === training.id ? 'active' : ''}`} 
                        className={`domain-card ${activeIds.includes(training.id) ? 'active' : ''}`}
                        onClick={() => toggleActive(training.id)}
                        >
                            {training.popularTags.length > 0 && (
                                <div className="popular-badge">
                                    <span>
                                        <span style={{ fontSize: 10 }}>★</span>{' '}
                                        {training.popularTags.map((tag) => tag.state).join(' · ')} {' . '}
                                        {training.popularTags.map((tag) => tag.demanded).join(' · ')}
                                    </span>
                                </div>
                            )}
                            <div
                                className="domain-icon"
                                style={{ background: "#EEEDFE", color: "#3C3489" }}
                            >
                                🤖
                            </div>
                            <div className="domain-name">{training.title}</div>
                            <div className="domain-desc">
                                {training.description}
                            </div>
                            <div className="domain-meta">
                                <div className="meta-item">
                                    Durée <span className="meta-val">{training.duration}</span>
                                </div>
                                <div className="meta-item">
                                    {training.min_price !== "Sur devis" ? (<>À partir de <span className="meta-val">{training.min_price}</span></>) : (<><span className="meta-val">Tarif {training.min_price}</span></>)}
                                    {/* À partir de <span className="meta-val">{training.min_price}</span> */}
                                </div>
                            </div>
                            <div className="tag-list">
                                {training.technologies.map((technology) => (
                                    <span key={technology.id} className="tag">{technology.tag}</span>
                                ))}
                            </div>
                            <div id="detail-ia"
                            //  className={`detail-block ${activeId === training.id ? '' : 'hidden'}`}
                            className={`detail-block ${activeIds.includes(training.id) ? '' : 'hidden'}`}
                            >
                                {training.min_price !== "Sur devis" ? (
                                training.technologies.map((technology) => (
                                    <div key={technology.id} className="sub-card">
                                        <div className="sub-name">{technology.title}</div>
                                        <div className="sub-meta">
                                            {technology.duration} jours · {technology.description}
                                        </div>
                                        <div className="sub-price">{technology.price} FCFA</div>
                                    </div>
                                ))): (
                                    training.technologies.map((technology) => (
                                        <div className="feat-row">
                                            <div className="check-dot">
                                                <svg viewBox="0 0 10 10" width={10} height={10}>
                                                    <polyline
                                                        points="2,5 4,7.5 8,2.5"
                                                        fill="none"
                                                        stroke="#1D9E75"
                                                        strokeWidth="1.5"
                                                    />
                                                </svg>
                                            </div>
                                            {technology.title}
                                        </div>
                                    ))
                                )}
                            </div>
                            <div className="card-footer">
                                <div>
                                    {training.min_price !== "Sur devis" ? (<>
                                        <div className="price-main">{training.min_price} – {training.technologies.reduce((max, tech) => tech.price > max ? tech.price : max, training.technologies[0]?.price || 0)}</div>
                                        <div className="price-sub">FCFA / participant</div>
                                    </>):(<>
                                        <div className="price-main">{training.min_price}</div>
                                        <div className="price-sub">Selon effectif &amp; durée</div>
                                    </>)}
                                    {/* <div className="price-main">{training.min_price} – {training.technologies.reduce((max, tech) => tech.price > max ? tech.price : max, training.technologies[0]?.price || 0)}</div>
                                    <div className="price-sub">FCFA / participant</div> */}
                                </div>
                                <button
                                    className="enroll-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleInscribe(training.title);
                                    }}
                                >
                                    {training.min_price !== "Sur devis" ? "S'inscrire" : "Devis"}
                                </button>
                            </div>
                        </div>
                        )))
                    )}
                </div>
        </div>

            {/* <div
             className="domain-card" 
            //  onClick="toggleDomain(this,'intra')"
            >
                <div
                    className="domain-icon"
                    style={{ background: "#E1F5EE", color: "#085041" }}
                >
                    🏢
                </div>
                <div className="domain-name">Formation intra-entreprise</div>
                <div className="domain-desc">
                    Programmes sur mesure dispensés dans vos locaux, adaptés à votre secteur et
                    vos équipes.
                </div>
                <div className="domain-meta">
                    <div className="meta-item">
                        Durée <span className="meta-val">Sur mesure</span>
                    </div>
                    <div className="meta-item">
                        Tarif <span className="meta-val">Sur devis</span>
                    </div>
                </div>
                <div className="tag-list">
                    <span className="tag">Intra-entreprise</span>
                    <span className="tag">Sur mesure</span>
                    <span className="tag">Certifiant</span>
                </div>
                <div id="detail-intra" className="hidden detail-block">
                    <p
                    style={{
                        fontSize: 13,
                        color: "#555",
                        lineHeight: "1.6",
                        marginBottom: 10
                    }}
                    >
                        OVA Consulting conçoit et anime des sessions dans vos locaux, adaptées à
                        votre secteur et au niveau de vos équipes.
                    </p>
                    <div className="feat-row">
                        <div className="check-dot">
                            <svg viewBox="0 0 10 10" width={10} height={10}>
                                <polyline
                                    points="2,5 4,7.5 8,2.5"
                                    fill="none"
                                    stroke="#1D9E75"
                                    strokeWidth="1.5"
                                />
                            </svg>
                        </div>
                        Audit des besoins avant formation
                    </div>
                    <div className="feat-row">
                        <div className="check-dot">
                            <svg viewBox="0 0 10 10" width={10} height={10}>
                                <polyline
                                    points="2,5 4,7.5 8,2.5"
                                    fill="none"
                                    stroke="#1D9E75"
                                    strokeWidth="1.5"
                                />
                            </svg>
                        </div>
                        Supports pédagogiques personnalisés
                    </div>
                    <div className="feat-row">
                        <div className="check-dot">
                            <svg viewBox="0 0 10 10" width={10} height={10}>
                                <polyline
                                    points="2,5 4,7.5 8,2.5"
                                    fill="none"
                                    stroke="#1D9E75"
                                    strokeWidth="1.5"
                                />
                            </svg>
                        </div>
                        Attestation de formation remise
                    </div>
                    <div className="feat-row">
                        <div className="check-dot">
                            <svg viewBox="0 0 10 10" width={10} height={10}>
                                <polyline
                                    points="2,5 4,7.5 8,2.5"
                                    fill="none"
                                    stroke="#1D9E75"
                                    strokeWidth="1.5"
                                />
                            </svg>
                        </div>
                        Suivi post-formation 30 jours
                    </div>
                </div>
                <div className="card-footer">
                    <div>
                        <div className="price-main">Sur devis</div>
                        <div className="price-sub">Selon effectif &amp; durée</div>
                    </div>
                    <button
                        className="enroll-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleInscribe('Formation intra-entreprise');
                        }}
                        // onClick="event.stopPropagation();inscribe('Formation intra-entreprise')"
                    >
                        Demander un devis
                    </button>
                </div>
            </div> */}
            {/* <ContactBar /> */}
        </>
    )

};

export default Catalog;